import { render, staticRenderFns } from "./Ability.vue?vue&type=template&id=3e4f9a72&"
import script from "./Ability.vue?vue&type=script&lang=js&"
export * from "./Ability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports